<template>
<div class="title">
  <slot />
</div>
</template>

<script>
export default {
  name: 'index'
}
</script>

<style lang="less" scoped>
.title{
  font-weight: 400;
  font-size: 36px;
  color: #374475;
  line-height: 34px;
  position: relative;
  margin-left: 262px;
  padding-left: 18px;
  margin-top: 32px;

  &:before{
    content: '';
    position: absolute;
    top: 0px;
    left: 0px;
    width: 3px;
    height: 17px;
    background: #374475;
  }
  &:after{
    content: '';
    position: absolute;
    top: 17px;
    left: 0px;
    width: 3px;
    height: 17px;
    background: #E29C4F;
  }
  .key{
    font-size: 36px;
  }
}
</style>
